import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const useWikiImportEnabled = (): boolean =>
  useApi(configApiRef).getOptionalBoolean('wikiImport.enabled') ?? false;
